import axiosInstance from "./axiosInstance";

export const getAuthHeader = () => { 
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getUserPermissions = async () => {
  const response = await axiosInstance.get("/Auth/me/permissions", {
    headers: getAuthHeader(),
  });
  return response.data;
};